var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container"},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left","size":"lg"},on:{"click":_vm.back}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }